import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert } from "../../../utils"
import RoutesMap from "../../../route_control/RouteControl"

export const stockDetailsTodo = createAsyncThunk('stockDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `asset_stock_details/${id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

export const itemIssueHistoryTodo = createAsyncThunk('itemIssueHistory', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_issue/history/${id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        if (error?.response?.status == 401) {
            navigate(RoutesMap.LOGIN.path)
        } else if (error?.response?.status == 403) {
            showAccessDeniedAlert(navigate)
        }
        return error.response
    }
})

const stockDetailsSlice = createSlice({
    name: 'stockDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(stockDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(stockDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default stockDetailsSlice.reducer;
